import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-mail-dir-icon',
	template: '<img class="mail-icon-img" [src]="getSrc()" />',
	styles: [`.mail-icon-img {
	width: 20px;
	height: auto;
	margin-top: 10px;
}`]
})
export class MailDirIconComponent {
	@Input() direction: string = "in";
	path = "../../../assets/img/";
	getSrc() {
		if (this.direction === "out") {
			return `${this.path}arrow-up-right-circle.svg`;
		} else {
			return `${this.path}arrow-down-left-circle.svg`;
		}
	}
}
